<template>
  <div class="sum-description-component">
    <div class="columns">
        <div class="column is-truncate-text is-8">
          <span class="is-size-6 has-text-weight-bold has-text-grey-secondary is-no-wrap">
            {{ name }}
          </span>
        </div>
        <div class="column is-4">
          <span class="is-pulled-right">
            <span class="is-size-6 has-text-weight-light has-text-grey-secondary">
              R$ {{ price }}
            </span>
          </span>
        </div>
      </div>
  </div>
</template>

<script>

export default {

  name: 'review-extra-services-sub-item',

  props: {
    name: {
      required: true,
      type: String
    },
    price: {
      required: true,
      type: String
    }
  },

}

</script>